<template>
  <div>
    <Detail></Detail>
  </div>
</template>

<script>
import Detail from '@/views/MInformationService/pages/detail'
export default {
  data () {
    return {

    }
  },
  components: { Detail },
}
</script>
